// extracted by mini-css-extract-plugin
export default {"loading":"LoadingIndicator-loading-DWfav","rippleContainer":"LoadingIndicator-rippleContainer-b3h1D","ripple":"LoadingIndicator-ripple-Dn9J1"};